<template>
  <div class="game-list">
    <div class="game-item" v-for="(game, index) in games" :key="index"  @click="startGame(game)">
      <img :src="game.images[0]" alt="game image" class="game-image" />
      <h2>{{ game.name }}</h2>
      <!--
      <p>{{ game.description }}</p>
      <button @click="startGame(game)">Play</button>
      -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    games: Array, // 接收父组件传递的游戏数据
  },
  methods: {
    startGame(game) {
      window.location.href = game.url;
    },
  },
   mounted() {
    
  },
  beforeUnmount() {
    // 清理：移除 script 防止内存泄漏或重复加载
    if (this.injectedScript && this.injectedScript.parentNode) {
      this.injectedScript.parentNode.removeChild(this.injectedScript);
    }
    // 注意：广告生成的 iframe 通常不需要手动清理
  }
};
</script>

<style scoped>
.game-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin:10px;
  gap: 5px;
}

.game-item {
  text-align: center;
  width: 100%;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 10px;
}

.game-item h2 {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden;    /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 如果文本过长，显示省略号 */
  margin:0px;
}

.game-image {
  width: 100%;
  height:50%;
  max-height:300px;
  border-radius: 5px;
}

button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
